import { render } from "./ModalSlopeExtend.vue?vue&type=template&id=6e387a2c&scoped=true"
import script from "./ModalSlopeExtend.vue?vue&type=script&lang=js"
export * from "./ModalSlopeExtend.vue?vue&type=script&lang=js"

import "./ModalSlopeExtend.vue?vue&type=style&index=0&id=6e387a2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e387a2c"]])

export default __exports__